import React from "react";
import styles from "../../styles/HomePage.module.css"; // ✅ Required import


const SearchBar = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Search functionality would be implemented here");
  };

  return (
    <div className={styles.container}>
      <div className={styles.searchBar}>
        <form className={styles.searchForm} onSubmit={handleSubmit}>
          <div>
            <label htmlFor="make">Make</label>
            <select id="make" name="make">
              <option value="">All Makes</option>
              <option value="maruti">Maruti</option>
              <option value="hyundai">Hyundai</option>
              <option value="tata">Tata</option>
              <option value="mahindra">Mahindra</option>
              <option value="honda">Honda</option>
            </select>
          </div>
          <div>
            <label htmlFor="model">Model</label>
            <select id="model" name="model">
              <option value="">All Models</option>
              <option value="swift">Swift</option>
              <option value="i20">i20</option>
              <option value="nexon">Nexon</option>
              <option value="scorpio">Scorpio</option>
              <option value="city">City</option>
            </select>
          </div>
          <div>
            <label htmlFor="price">Price</label>
            <select id="price" name="price">
              <option value="">Any Price</option>
              <option value="1">Under ₹2 Lakh</option>
              <option value="2">₹2-5 Lakh</option>
              <option value="3">₹5-10 Lakh</option>
              <option value="4">Over ₹10 Lakh</option>
            </select>
          </div>
          <div>
            <label htmlFor="location">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              placeholder="Enter City"
            />
          </div>
          <button type="submit" className={`${styles.btn} ${styles.searchBtn}`}>
            Search
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
